import _ from 'lodash'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import MarkedField from 'scoreboard/components/marked-field'
import urlValidator from 'scoreboard/components/validators/url-validator'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import template from './you-tube-video.hbs'

const YouTubeVideo = Backbone.View.extend({

	events: {
		'click .delete-video': 'onDelete'
	},

	initialize(options = {}) {
		this.options = options
	},

	render: function() {
		this.$el.empty().append(template(this.model))

		this.markedField = new MarkedField({
			el: this.$('.video-url'),
			validator: urlValidator
		}).render()

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		return this
	},

	videoId() {
		return getIdFromUrl(this.markedField.val())
	},

	markInvalid() {
		this.markedField.error(i18n.get('home.welcome.youTube.missing', this.videoId()))
	},

	onDelete() {
		this.remove()
		this.trigger('delete')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.markedField, this.covertButtonTooltips], 'remove')
	}

})

/**
 * Extracts the video id from a variety of possible youtube urls.

 * There may be false negatives, so only call this function if you know the url
 * is a youtube video url.
 *
 * Taken from: https://gist.github.com/takien/4077195
 */
function getIdFromUrl(youTubeUrl) {
	var videoId = ''
	if (!_.isEmpty(youTubeUrl)) {
		var url = youTubeUrl.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
		if (url[2] !== undefined) {
			videoId = url[2].split(/[^0-9a-z_\-]/i)
			videoId = videoId[0]
		} else {
			videoId = url[0]
		}
	}
	return videoId
}

/**
 * Constructs a youtube URL in format that will play in an embedded iFrame.
 *
 * @param {String} videoId
 * @param {boolean} [opts.autoplay=true]
 * @param {boolean} [opts.related=false] If the rel parameter is set to 0,
 * 	related videos will come from the same channel as the video that was just played.
 * 	see: https://developers.google.com/youtube/player_parameters#rel
 */
function buildUrl(videoId, opts = {}) {
	const options = _.extend({autoplay: true, related: false}, opts)
	const autoplay = options.autoplay ? 1 : 0
	const related = options.related ? 1 : 0
	return `https://www.youtube.com/embed/${videoId}?autoplay=${autoplay}&rel=${related}`
}

_.extend(YouTubeVideo, {
	getIdFromUrl,
	buildUrl
})

export default YouTubeVideo
export { getIdFromUrl, buildUrl }

YouTubeVideo.__filename__ = 'home/you-tube-video.js'
